import { useState, useCallback } from "react";

export type CfdiRelacionado = { tiporelacion: string; uuid: string };

export function useRelacionados() {
  const [relModalOpen, setRelModalOpen] = useState(false);
  const [cfdirelacionados, setCfdirelacionados] = useState<CfdiRelacionado[]>(
    []
  );

  const open = useCallback(() => setRelModalOpen(true), []);
  const close = useCallback(() => setRelModalOpen(false), []);

  const confirmRelacion = useCallback(
    (data: any) => {
      const tiporelacion =
        data?.tiporelacion ?? data?.motivo?.value ?? data?.motivo ?? "";
      const uuid = data?.uuid ?? data?.uuid_sat ?? "";
      if (!tiporelacion || !uuid) {
        close();
        return;
      }
      setCfdirelacionados((prev) => {
        const sinDup = prev.filter((r) => r.uuid !== uuid);
        return [
          ...sinDup,
          { tiporelacion: String(tiporelacion), uuid: String(uuid) },
        ];
      });
      close();
    },
    [close]
  );

  const remove = useCallback((uuid: string) => {
    setCfdirelacionados((prev) => prev.filter((r) => r.uuid !== uuid));
  }, []);

  return {
    relModalOpen,
    open,
    close,
    confirmRelacion,
    cfdirelacionados,
    remove,
    setCfdirelacionados,
  };
}
